import { useFormContext } from 'react-hook-form';
import { FolderPermissionLevel } from '../../../../../api/types.gen';
import { IPermissionsDialogForm } from '../PermissionsDialogForm';
import { getFormStateFromPermissionLevel } from '../utilities/getFormStateFromPermissionLevel';

interface IUseSetFormStateFromPermissionLevelReturn {
  updateFormStateBasedOnPermissionLevel: (newLevel: FolderPermissionLevel | undefined) => void;
}

export function useSetFormStateFromPermissionLevel(): IUseSetFormStateFromPermissionLevelReturn {
  const { setValue } = useFormContext<IPermissionsDialogForm>();

  function updateFormStateBasedOnPermissionLevel(newLevel: FolderPermissionLevel | undefined): void {
    if (!newLevel || newLevel === FolderPermissionLevel.CUSTOM) {
      return;
    }

    const newFormState = getFormStateFromPermissionLevel(newLevel);

    Object.entries(newFormState).forEach(([k, v]) => {
      if (v === null || v === undefined) {
        return;
      }

      setValue(k as keyof IPermissionsDialogForm, v, {
        shouldValidate: false,
      });
    });
  }

  return { updateFormStateBasedOnPermissionLevel };
}
